export { default as appConfig } from "assets/config/application.json";
export { default as routePath } from "assets/config/routes.json";
export { default as firebaseConfig } from "assets/config/firebase.json";
